// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qe3G","col":"styles_col__2ZSCt","actions":"styles_actions__1Ivak","conflict":"styles_conflict__34nqS"};